// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "showTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listRfqQuoteContentsOfRfqTableDiv",
        "totalFound": "1"
      },
      "deps": "js/rfqHelper"
    },
    "showHideTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listRfqQuoteContentsOfRfqTableDiv",
        "totalFound": "{{data.totalFound}}"
      },
      "deps": "js/rfqHelper"
    },
    "addSelectedRfqQuoteIdToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "selectedRfqQuoteId",
        "value": "{{parameters.eventData}}"
      }
    },
    "getRfqQuoteContentsOfRfq": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getRfqQuoteContentsOfRfq( $collaborationspaceId: String, $rfqId: String, $skip: Int) { getRfqQuoteContentsOfRfq( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, skip: $skip) { items totalCount error}}",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "rfqId": "{{props.rfqid}}",
              "skip": "{{data.RfqQuoteContentsSkip}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "dataParsers": [{
        "id": "rfqQuoteContentsOfRfqParser",
        "responseObjs": "data.data.getRfqQuoteContentsOfRfq.items"
      }],
      "outputData": {
        "filterResults": "data.data.getRfqQuoteContentsOfRfq.items",
        "totalFound": "data.data.getRfqQuoteContentsOfRfq.totalCount",
        "error": "data.data.getRfqQuoteContentsOfRfq.error"
      },
      "actionMessages": {},
      "events": {
        "success": [{
          "condition": "error === null || error === undefined",
          "name": "list-rfq-quote-contents-of-rfq.success"
        }, {
          "condition": "error === 'EMPTY_COLLAB_SPACE'",
          "name": "list-rfq-quote-contents-of-rfq.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 400 || errorCode === 400",
          "name": "list-rfq-quote-contents-of-rfq.error",
          "eventData": {
            "error": "{{error}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 403 || errorCode === 403",
          "name": "list-rfq-quote-contents-of-rfq.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "list-rfq-quote-contents-of-rfq.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "error.statusCode >= 500 && error.statusCode <= 599",
          "name": "list-rfq-quote-contents-of-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "list-rfq-quote-contents-of-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "refreshContentsTable": {
      "actionType": "dataProvider",
      "method": "supplierResponseDataProvider"
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    }
  },
  "data": {
    "pageSize": 3,
    "RfqQuoteContentsSkip": 0
  },
  "dataProviders": {
    "supplierResponseDataProvider": {
      "action": "getRfqQuoteContentsOfRfq",
      "response": "{{data.filterResults}}",
      "totalFound": "{{data.totalFound}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "columnProviders": {
    "supplierResponseColumnProvider": {
      "frozenColumnIndex": 0,
      "columns": [{
        "name": "supplierName",
        "displayName": "{{i18n.supplierName}}",
        "minWidth": 200,
        "width": 200,
        "enableColumnMenu": false,
        "pinnedLeft": true
      }, {
        "name": "supplierId",
        "displayName": "{{i18n.supplierId}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": false
      }, {
        "name": "rfqQuoteId",
        "displayName": "{{i18n.quoteId}}",
        "minWidth": 200,
        "width": 200,
        "enableColumnMenu": false
      }, {
        "name": "quoteFiles",
        "displayName": "{{i18n.quoteFiles}}",
        "minWidth": 100,
        "width": 100,
        "enableColumnMenu": false
      }, {
        "name": "comments",
        "displayName": "{{i18n.comments}}",
        "minWidth": 100,
        "width": 100,
        "enableColumnMenu": false
      }]
    }
  },
  "grids": {
    "quoteContentsOfRfqTable": {
      "dataProvider": "supplierResponseDataProvider",
      "columnProvider": "supplierResponseColumnProvider",
      "addIconColumn": false,
      "gridOptions": {
        "enablePinning": true,
        "enableSorting": false
      }
    }
  },
  "functions": {
    "filterRows": {
      "functionName": "filterRows",
      "parameters": ["{{data.dataProviders.supplierResponseDataProvider.startIndex}}", "{{data.pageSize}}"]
    }
  },
  "i18n": {
    "creationDate": ["RfqMessages"],
    "name": ["RfqMessages"],
    "filename": ["RfqMessages"],
    "filetype": ["RfqMessages"],
    "typename": ["RfqMessages"],
    "createdby": ["RfqMessages"],
    "downloadticket": ["RfqMessages"],
    "filesize": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"],
    "modifieddate": ["RfqMessages"],
    "modifiedby": ["RfqMessages"],
    "supplierName": ["RfqMessages"],
    "supplierId": ["RfqMessages"],
    "quoteId": ["RfqMessages"],
    "quoteFiles": ["RfqMessages"],
    "comments": ["RfqMessages"],
    "supplierResponse": ["RfqMessages"]
  },
  "onEvent": [{
    "eventId": "list-rfq-quote-contents-of-rfq.success",
    "action": "showHideTable",
    "cacheEventData": true
  }, {
    "eventId": "remove-rfq-contents.success",
    "action": "refreshContentsTable",
    "cacheEventData": true
  }, {
    "eventId": "add-contents-rfq.contentAdded",
    "action": "refreshContentsTable",
    "cacheEventData": true
  }, {
    "eventId": "supplierResponseDataProvider.selectionChangeEvent",
    "action": "addSelectedRfqQuoteIdToCtx",
    "inputArgs": {
      "eventData": "{{eventData.selectedObjects[0].props.rfqQuoteId.dbValue}}"
    }
  }, {
    "eventId": "supplierResponseDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-rfq-quote-contents-of-rfq.error",
      "eventData": {
        "rfqQuoteId": "eventData.selectedObjects[0].props.rfqQuoteId.dbValue"
      }
    }
  }, {
    "eventId": "list-rfq-quote-contents-of-rfq.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-rfq-quote-contents-of-rfq.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "dataParseDefinitions": {
    "rfqQuoteContentsOfRfqParser": {
      "identifier": "{{response.filename}}",
      "typeIconURL": "http://localhost:4012/assets/images/typeShareFolder48.svg",
      "type": "RFQ",
      "props": {
        "supplierName": {
          "name": "{{i18n.supplierName}}",
          "displayName": "{{i18n.supplierName}}",
          "value": "{{response.supplierName}}",
          "displayValue": "{{response.supplierName}}",
          "type": "String"
        },
        "supplierId": {
          "name": "{{i18n.supplierId}}",
          "displayName": "{{i18n.supplierId}}",
          "value": "{{response.supplierId}}",
          "displayValue": "{{response.supplierId}}",
          "type": "String"
        },
        "rfqQuoteId": {
          "name": "{{i18n.quoteId}}",
          "displayName": "{{i18n.quoteId}}",
          "value": "{{response.rfqQuoteId}}",
          "displayValue": "{{response.rfqQuoteId}}",
          "type": "String"
        },
        "quoteFiles": {
          "name": "{{i18n.quoteFiles}}",
          "displayName": "{{i18n.quoteFiles}}",
          "value": "{{response.quoteFiles}}",
          "displayValue": "{{response.quoteFiles}}",
          "type": "String"
        },
        "comments": {
          "name": "{{i18n.comments}}",
          "displayName": "{{i18n.comments}}",
          "value": "{{response.comments}}",
          "displayValue": "{{response.comments}}",
          "type": "String"
        }
      }
    }
  },
  "conditions": {
    "showSupplierResponse": {
      "expression": "(data.totalFound > 0)"
    }
  },
  "_viewModelId": "ListRfqQuoteContentsOfRfq",
  "_uniqueViewModelId": "ListRfqQuoteContentsOfRfq",
  "ctx": {}
};

/*
<aw-panel class="aw-layout-full">
    <aw-flex-row>
        <div id = "listRfqQuoteContentsOfRfqTableDiv" class="rfqHidden">
            <aw-panel-section class="aw-layout-full" caption="{{i18n.supplierResponse}}">
                <aw-flex-row>
                    <aw-splm-table gridid="quoteContentsOfRfqTable"></aw-splm-table>
                </aw-flex-row>
            </aw-panel-section>
        </div>
        <br>
        <div id="listRfqQuoteContentsOfRfqTableDiv-empty" class="rfqEmptyPage">
        </div>
    </aw-flex-row>
</aw-panel>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal,
    className: "aw-layout-full"
  }, /*#__PURE__*/React.createElement(AwFlexRow, null, /*#__PURE__*/React.createElement("div", {
    id: "listRfqQuoteContentsOfRfqTableDiv",
    className: "rfqHidden"
  }, /*#__PURE__*/React.createElement(AwPanelSection, {
    className: "aw-layout-full",
    caption: AwParseService.instance("i18n.supplierResponse")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwFlexRow, null, /*#__PURE__*/React.createElement(AwSplmTable, grids.quoteContentsOfRfqTable)))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    id: "listRfqQuoteContentsOfRfqTableDiv-empty",
    className: "rfqEmptyPage"
  })));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;